import React from 'react';
import { useTranslation } from 'react-i18next';
import { TextField } from '@material-ui/core';

const Input = (props) => {
  const { t, i18n } = useTranslation();

  const { inputHasErrors, label } = props;
  return <TextField fullWidth error={inputHasErrors} helperText={t(inputHasErrors)} {...props} />;
};

export default Input;
